import React from "react";

const FTFRStandards = ({ title, description, standards }) => {
  return (
    <section className="ftfr-standards-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="row g-4">
          {standards.map((standard, i) => (
            <div
              key={i}
              className="col-md-6"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="ftfr-standard-card">
                <p className="ftfr-standard-label">{standard.label}</p>
                <p className="ftfr-standard-desc">{standard.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FTFRStandards;
